import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getProfileThunk } from "./thunks";
import { IProfile, ProfileState } from "./types";

export const initialState: ProfileState = {
  data: null,
  loading: false,
  loaded: false,
  error: {},
  upLoading: false,
  upLoaded: false,
};

export const profileSlice = createSlice({
  name: "affProfileSlice",
  initialState,
  reducers: {
    resetProfileState: () => initialState,
    updateProfile: (
      state,
      action: PayloadAction<
        Pick<
          IProfile,
          "username" | "userLanguage" | "messenger" | "messengerType"
        >
      >
    ) => {
      if (!state.data) return;

      Object.assign(state.data, action.payload);
    },
  },
  extraReducers: builder => {
    builder.addCase(getProfileThunk.pending, state => {
      state.error = true;
      state.upLoading = true;
      state.upLoaded = true;
    });
    builder.addCase(getProfileThunk.fulfilled, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
      state.loaded = true;
      state.upLoading = false;
      state.upLoaded = false;
    });
  },
});

export const { resetProfileState, updateProfile } = profileSlice.actions;
export default profileSlice.reducer;
